import React from "react";
import Lottie from "react-lottie-player";
import loaderLottie from "../../assets/loader.json";

export default function Loader(props) {
  const { isMobile } = props;
  const lottieSize = isMobile ? "60vw" : "25vw";
  return (
    <div className="d-flex justify-content-center align-content-center h-100">
      <div className="d-flex align-self-center">
        <Lottie
          loop
          play
          animationData={loaderLottie}
          style={{ width: lottieSize, height: lottieSize }}
        />
      </div>
    </div>
  );
}
